export const syncListItemWidth = (
  nodeList: Array<HTMLElement>,
  fillWithMargin = true,
  gap = 10,
): void => {
  if (!nodeList) return;
  let maxWidth = 0;
  nodeList.forEach(node => {
    maxWidth = Math.max(node.offsetWidth, maxWidth);
  });
  nodeList.forEach(node => {
    if (fillWithMargin)
      node.style.marginRight = `${maxWidth + gap - node.offsetWidth}px`;
    else {
      node.style.width = `${maxWidth}px`;
      node.style.marginRight = `${gap}px`;
    }
  });
};
